const ASCENDING = "ASC";
const DESCENDING = "DESC";

const defaultSortOptions = {
    nullsLast: true
}

export const sort = (selector, direction, options = {}) => (x, y) => {
    const opts = { ...defaultSortOptions, ...options };

    const valX = selector(x);
    const valY = selector(y);

    if (valX === null || valX === undefined || valX === "") {
        return opts.nullsLast ? -1 : 1;
    }

    if (valX === valY) {
        return 0;
    }

    if (valX > valY) {
        return direction === ASCENDING ? 1 : -1;
    }

    return direction === ASCENDING ? -1 : 1;
}

export const direction = {
    ASCENDING,
    DESCENDING
};

export const ascending = (selector, options = {}) => sort(selector, ASCENDING, options);

export const descending = (selector, options = {}) => sort(selector, DESCENDING, options);